<template>
  <Tooltip :title="status?.label">
    <svg :width="width" :height="height" viewBox="0 0 24 24" :style="'color: ' + color">

      <g v-if="status?.value === 'command'"
         fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path
        d="M6.5 7h11M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"></path><path
        d="M6 4v2a6 6 0 1 0 12 0V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z"></path>
      </g>
      <g v-else-if="status?.value === 'in_warehouse'"
         fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <path d="M3 21V8l9-4l9 4v13"/>
        <path d="M13 13h4v8H7v-6h6"/>
        <path d="M13 21v-9a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3"/>
      </g>
      <g v-else-if="status?.value === 'out_of_warehouse'"
         fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <path d="M4 19v2h16V7l-8-4l-8 4v2m9 5H4"/>
        <path d="m7 11l-3 3l3 3"/>
      </g>

      <path v-else-if="status?.value === 'under_maintenance'" fill="none" stroke="currentColor" stroke-width="2"
            d="M19 10V2H7v12h7V7H2v12h8m4 4l6-6m1-3a2 2 0 1 0 2 2"/>

      <g v-else-if="status?.value === 'out_of_order'"
         fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <path d="M5 5a2 2 0 0 0 2 2m2-2a2 2 0 0 0-2-2M5 22v-5l-1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4l-1 1v5"/>
        <circle cx="17" cy="5" r="2"/>
        <path
          d="M15 22v-4h-2l1.254-3.763m1.036-2.942A.997.997 0 0 1 16 11h2a1 1 0 0 1 1 1l1.503 4.508M19 19v3M3 3l18 18"/>
      </g>
      <path v-else-if="status?.value === 'sold'"
            fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M16.7 8A3 3 0 0 0 14 6h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1-2.7-2M12 3v3m0 12v3"/>
      <path v-else-if="status?.value === 'destroyed'"
            fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M10 21h4v-9h5V8h-5V3h-4v5H5v4h5z"/>
    </svg>
  </Tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { status as equipmentStatus } from '../../utils/equipment-status.js'
import Tooltip from '@/components/ui/Tooltip.vue'
import type { EquipmentStatus } from '../../types/equipement'

interface Props {
  status: EquipmentStatus | null
  width?: number
  height?: number
}

const props = withDefaults(defineProps<Props>(), {
  width: 24,
  height: 24,
})

const color = computed(() => {
  if (!props.status) return ''
  return equipmentStatus.find((item) => item.value === props.status!.value)?.color || ''
})
</script>
